import dynamic from "next/dynamic";

export const ContentSideImage = dynamic(() => import("./component"));
